<template>
	<div class="recommendation__loader">
		<content-loader
			:speed="1"
			width="320"
			height="51"
			primaryColor="var(--line-11)"
			secondaryColor="var(--lightest-blue)"
		>
			<rect x="5" y="16" rx="2" ry="2" width="88" height="5" />
			<rect x="5" y="30" rx="2" ry="2" width="88" height="5" />

			<rect x="250" y="0" rx="2" ry="2" width="70" height="5" />

			<rect x="184" y="15" rx="13" ry="13" width="42" height="22" />
			<rect x="230" y="15" rx="13" ry="13" width="42" height="22" />
			<rect x="276" y="15" rx="13" ry="13" width="42" height="22" />

			<rect x="250" y="46" rx="2" ry="2" width="70" height="5" />
		</content-loader>
	</div>
</template>
<script>
import { ContentLoader } from "vue-content-loader";

export default {
	components: { ContentLoader },
};
</script>
<style lang="scss" scoped>
.recommendation {
	&__loader {
		padding: 15px;
		border-radius: 8px;
		border: 1px solid var(--light-gray-border);
		background-color: var(--black-dark-20);
	}
}
</style>
